/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Not_OrganizerInputs */



/**
* | output |
* | --- |
* | "Only organizers can perform this action" |
*
* @param {Err_Tournament_Not_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_not_organizer = /** @type {((inputs?: Err_Tournament_Not_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Not_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs peuvent effectuer cette action")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores pueden realizar esta acción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores podem realizar esta ação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori possono eseguire questa azione")
	return /** @type {LocalizedString} */ ("Only organizers can perform this action")
});